import {WalletAdapter} from "../../wallets";
import BN from "bn.js";
import {Detail, Reserve} from "../../models";
import {Connection, PublicKey, Signer, TransactionInstruction} from "@solana/web3.js";
import {createWithdrawMiningInstruction} from "../../models/instructions/withdrawMining";

export const withdrawMining = async (
    connection:Connection,
    signers: Signer[],
    instructions: TransactionInstruction[],
    cleanupInstructions: TransactionInstruction[],
    mining:PublicKey,
    destinationAccount:PublicKey,
    reserve:Detail<Reserve>,
    withdrawAmount:BN,
    wallet:WalletAdapter,
    lendingMarket:PublicKey,
    lendingProgaramId:PublicKey

) => {
    if (wallet.publicKey == null){
        throw new Error("wallet need connection")
    }
    const [lendingMarketAuthority] = await PublicKey.findProgramAddress(
        [lendingMarket.toBuffer()],
        lendingProgaramId,
    );
    instructions.push(createWithdrawMiningInstruction(
        mining,
        withdrawAmount,
        destinationAccount,
        reserve,
        lendingMarket,
        lendingMarketAuthority,
        wallet.publicKey,
        lendingProgaramId
    ))
}